import React, { type PropsWithChildren } from "react";

import clsx from "clsx";
import { motion } from "framer-motion";

import { type TableTreeColumn } from "@devexpress/dx-react-grid-bootstrap4";

const ENTER_KEY_CODE = 13;
const SPACE_KEY_CODE = 32;

const handleMouseDown = (e: any) => {
  e.target.style.outline = "none";
};

const handleBlur = (e: any) => {
  e.target.style.outline = "";
};

export const TableTreeColumnExpandButton = ({
  visible,
  expanded,
  onToggle,
  isCompacted,
  ...restProps
}: PropsWithChildren<
  TableTreeColumn.ExpandButtonProps & { isCompacted: boolean }
>) => {
  if (!visible) {
    return null;
  }

  const handleClick = (e: any) => {
    e.stopPropagation();
    onToggle();
  };

  const handleKeyDown = (e: any) => {
    if (e.keyCode === ENTER_KEY_CODE || e.keyCode === SPACE_KEY_CODE) {
      e.preventDefault();
      onToggle();
    }
  };

  return (
    <button
      className={clsx(
        "w-6 h-6 self-center text-xs text-cosmic hover:text-cosmic+1 hover:bg-cosmic-2 rounded-lg",
        { "mr-2.5": !isCompacted, "mr-1": isCompacted },
      )}
      tabIndex={visible ? 0 : undefined}
      onKeyDown={handleKeyDown}
      onMouseDown={handleMouseDown}
      onBlur={handleBlur}
      onClick={handleClick}
      {...restProps}
    >
      <motion.i
        className="fa-regular fa-sharp fa-chevron-right font-extrabold"
        initial={false}
        animate={{ rotate: expanded ? 90 : 0 }}
        transition={{ duration: 0.5 }}
      />
    </button>
  );
};
